import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
  invoiceGroupCount: null,
  funderCreditLimitChart: null,
  contacts: 0,
  funders: [],
  invoices: 0,
  estimates: 0,
  purchaseOrders:0,
  expenses: 0,
  totalDueAmount: [],
  isDataLoaded: false,

  weeklyInvoices: {
    days: [],
    counter: []
  },

  chartData: {
    months: [],
    invoiceTotals: [],
    outstandingInvoiceTotals: [],
    expenseTotals: [],
    netProfits: [],
    receiptTotals: []
  },

  outstandingInvoicesTotal: null,
  salesTotal: null,
  totalReceipts: null,
  totalExpenses: null,
  netProfit: null,

  dueInvoices: [],
  offerInvoices: [],
  recentEstimates: [],
  newContacts: [],
  RateOfPrePayment: []
}

export default {
  namespaced: true,

  state: initialState,

  getters: getters,

  actions: actions,

  mutations: mutations
}
